import React from 'react'
import {useTranslation} from 'i18n'
import {ConfirmationModal} from 'common/components'
import {GiftShopSettingPackageFormDeleteModalProps} from './GiftShopSettingPackageFormDeleteModalProps'

export default function GiftShopSettingPackageFormDeleteModal({
  visible,
  onConfirm,
  toggleModal,
}: GiftShopSettingPackageFormDeleteModalProps) {
  const {translate} = useTranslation()

  return (
    <ConfirmationModal
      visible={visible}
      title={translate('giftShop:settingPackageDeleteTitle')}
      text={translate('giftShop:settingPackageDeleteDescription')}
      onConfirm={onConfirm}
      toggleModal={toggleModal}
      confirmText={translate('global:yesImSure')}
      cancelText={translate('global:cancel')}
    />
  )
}
